// HeroSection.jsx
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { FaChartLine, FaSmile, FaUsers } from "react-icons/fa";
import heroImg from "../assets/19.png";
import "../css/Together.css";

const Stat = ({ value, label, suffix, icon }) => {
  return (
    <motion.div
      className="landing-page-techvison-mz-stat-card"
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 200 }}
    >
      <div className="landing-page-techvison-mz-stat-icon">{icon}</div>
      <h2>
        <CountUp
          start={0}
          end={value}
          duration={2.5}
          suffix={suffix || ""}
          enableScrollSpy={true}
        />
      </h2>
      <p>{label}</p>
    </motion.div>
  );
};

const HeroSection = () => {
  return (
    <section className="landing-page-techvison-mz-hero-container">
      {/* Left image */}
      <motion.div
        className="landing-page-techvison-mz-hero-left"
        initial={{ opacity: 0, x: -80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <img src={heroImg} alt="Community Support" />
      </motion.div>

      {/* Right content */}
      <motion.div
        className="landing-page-techvison-mz-hero-right"
        initial={{ opacity: 0, x: 80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h1>
          Empowering{" "}
          <motion.span
            className="landing-page-techvison-mz-animated-word"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            financial futures
          </motion.span>{" "}
          together
        </h1>
        <p>
          With a commitment to integrity, expertise, and personalized service,
          we strive to build lasting relationships based on trust and mutual
          success.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="landing-page-techvison-mz-cta-btn"
        >
          Know more about us
        </motion.button>

        {/* Dynamic Stats */}
        <div className="landing-page-techvison-mz-stats">
          <Stat
            value={99}
            suffix="%"
            label="Client Satisfaction"
            icon={<FaSmile />}
          />
          <Stat
            value={150}
            suffix="%"
            label="Company Growth"
            icon={<FaChartLine />}
          />
          <Stat
            value={120}
            label="Weekly New Users"
            icon={<FaUsers />}
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
